import resume from '../assets/pdf/SindhuResume.pdf'

export const headerData = {
    name: 'Dr Sindhusha Gundlapally',
    title: "Gynecologist",
    desciption:"I chose a career in obstetrics and gynecology because there's something about honoring women, honoring the birth process. We all come from Women and there is something extra ordinary about women",
    image: 'https://babycatcher-static.s3.ap-south-1.amazonaws.com/imgs/Sindhu_Portfolio-Pic-4.jpg',
    resumePdf: resume
}
